export type Difficulty = "easy" | "medium" | "hard";

export const getDifficultyConfig = (d: Difficulty = "medium") => ({
  rounds: d === "easy" ? 7 : d === "hard" ? 15 : 10,
  timeout: d === "easy" ? 1800 : d === "hard" ? 800 : 1200,
  label: d === "easy" ? "سهل" : d === "hard" ? "صعب" : "متوسط",
  emoji: d === "easy" ? "🟢" : d === "hard" ? "🔴" : "🟡",
});
